module.exports = __webpack_public_path__ + "static/portfolio-4-f8dc9e7d342a4ef37155118883da5754.jpg";